module.exports = __webpack_public_path__ + "img/quizpoker1.774ff0ba.webp";